export default "__VITE_ASSET__Clgh3q$f__"